import React from "react";
import { sortByForm } from "../../../utils/generalLiveCenter";

// import "./FootballStandingTable.scss";

const FootballStandingTable = ({ data, disable = false, name }) => {
  const sortedData = sortByForm(data);

  return (
    <div
      className={`global_table football_form_table ${disable ? "d-none" : ""}`}
      data-name={name}
    >
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Table</th>
            <th>Form</th>
          </tr>
        </thead>
        <tbody>
          {sortedData?.map((row, index) => {
            if (!row?.form) return null;
            let result;
            try {
              result = typeof row.form === 'string' ? JSON.parse(row.form) : row.form;
            } catch {
              return null;
            }
            if (!Array.isArray(result)) return null;
            return (
              <tr key={index + row?.nm}>
                <td>{index + 1}</td>
                <td>
                  <div className="des-wrap">
                    <span className="des-text">{row?.team?.nm}</span>
                  </div>
                </td>
                <td>
                  <ul className="match_score_list">
                    {result?.map((score, scoreIndex) => (
                      <li
                        key={`${scoreIndex}-${score}`}
                        className={
                          score === "W"
                            ? "green"
                            : score === "D"
                              ? "grey"
                              : score === "L"
                                ? "red"
                                : ""
                        }
                      >
                        {score}
                      </li>
                    ))}
                  </ul>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FootballStandingTable;
